import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';

import css from '../../ProfilePage.module.css';

const ReviewsErrorMaybe = ({ queryReviewsError }) => {

  return queryReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    </p>
  ) : null;
};

export default ReviewsErrorMaybe;
